import { Helmet } from "react-helmet"
import { LoadingSpinner } from "../components/BaseComponents"
import PageTemplate from "../components/BaseComponents/PageTemplate/PageTemplate"
import { useContext, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { userContext } from "../context/UserContext";
import { useAppDispatch } from "../redux/hooks/reduxHooks";
import { ACCOUNTINGPERIODS_RESET } from "../redux/slices/accountingPeriodsSlice";

function AssumeOrganisation() {
    const { setCompanyAssumption, companyAssumption, userData } = useContext(userContext)
    const { companyId, assumptionType } = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const assumptionRequested = useRef(false);

    useEffect(() => {
        // The context clears a refused assumption (and notifies the user): go back to the list the
        // user came from rather than spinning forever.
        if(companyAssumption) {
            assumptionRequested.current = true;
        } else if(assumptionRequested.current) {
            navigate(-1)
        }
    }, [companyAssumption, navigate])

    useEffect(() => {
        if(!setCompanyAssumption) {
            return;
        }
        if(!companyId || !assumptionType) {
            return;
        }
        // Clear accounting periods state when switching company context
        dispatch(ACCOUNTINGPERIODS_RESET())
        setCompanyAssumption({
            companyId,
            type: assumptionType as any,
        })
		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyId])

    useEffect(() => {
        // Check if the assumption was successful by verifying that the userData now reflects the assumed company
        if(userData?.access?.assumedCompanyType === assumptionType && userData?.companyId === companyId) {
            navigate('/', { replace: true })
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData])

	return (
		<PageTemplate testid='add-accounting-periods-main'>
			<Helmet>
				<title>Loading</title>
			</Helmet>
            <LoadingSpinner />
        </PageTemplate>
	)
}

export default AssumeOrganisation
